import { Dispatch } from 'react';

import axios from 'axios';

import { ReorderData, SuggestedNeedItem } from './types';

export const getPOItemsAnalytics = async (
  shopID: number,
  itemIDs: number[],
  setData: Dispatch<ReorderData>,
  setError: Dispatch<Error>
) => {
  if (!Number.isInteger(shopID)) {
    setError(new Error('Invalid shop ID'));
    return;
  }

  if (!itemIDs?.length) {
    setError(new Error('No items to query'));
    return;
  }

  try {
    const join = itemIDs.join(',');
    const call = `/admin/analytics/item/dynamic-reorder?item_ids=${join}&shop_id=${shopID}`;

    const response = await axios.get(call);
    setData(response.data);
  } catch (error) {
    setError(error);
  }
};

export const setPOItemsNeeds = async (suggestedNeeds: SuggestedNeedItem[]) => {
  if (!suggestedNeeds?.length) {
    return;
  }

  axios.put('/admin/analytics/order-line', suggestedNeeds);
};
